export const PORTFOLIO_CATEGORIES = {
  all: '전체',
  web: '웹 개발',
  mobile: '모바일 앱',
  solution: '솔루션',
  fullstack: '풀스택'
};

export const TECH_STACK = {
  // Frontend
  react: { name: 'React', color: '#61DAFB' },
  nextjs: { name: 'Next.js', color: '#000000' },
  vue: { name: 'Vue.js', color: '#4FC08D' },
  typescript: { name: 'TypeScript', color: '#3178C6' },
  tailwind: { name: 'Tailwind CSS', color: '#06B6D4' },
  
  // Backend
  nodejs: { name: 'Node.js', color: '#339933' },
  spring: { name: 'Spring', color: '#6DB33F' },
  django: { name: 'Django', color: '#092E20' },
  
  // Mobile
  reactnative: { name: 'React Native', color: '#61DAFB' },
  flutter: { name: 'Flutter', color: '#02569B' },
  swift: { name: 'Swift', color: '#FA7343' },
  
  // Database
  mysql: { name: 'MySQL', color: '#4479A1' },
  postgresql: { name: 'PostgreSQL', color: '#4169E1' },
  mongodb: { name: 'MongoDB', color: '#47A248' },
  
  // Cloud
  aws: { name: 'AWS', color: '#FF9900' },
  gcp: { name: 'GCP', color: '#4285F4' },
  azure: { name: 'Azure', color: '#0078D4' }
};

export const portfolioData = [
  {
    id: 1,
    title: 'E-Commerce Platform',
    client: '패션 브랜드 A사',
    category: 'fullstack',
    description: '대규모 패션 이커머스 플랫폼 구축. 실시간 재고 관리, AI 기반 추천 시스템, 다국어 지원 기능 구현',
    thumbnail: 'https://via.placeholder.com/600x400/4F46E5/ffffff?text=E-Commerce',
    duration: '6개월',
    teamSize: 8,
    technologies: ['react', 'nextjs', 'nodejs', 'postgresql', 'aws'],
    features: [
      '실시간 재고 관리 시스템',
      'AI 기반 상품 추천',
      '다국어 지원 (5개 언어)',
      '모바일 반응형 디자인'
    ],
    results: {
      conversionRate: '+35%',
      performance: '초기 로딩 2초 이내',
      userGrowth: '월간 사용자 200% 증가'
    }
  },
  {
    id: 2,
    title: 'Healthcare Management System',
    client: '병원 네트워크 B',
    category: 'solution',
    description: '병원 통합 관리 시스템. 환자 예약, 의료 기록 관리, 원격 진료 플랫폼 구축',
    thumbnail: 'https://via.placeholder.com/600x400/10B981/ffffff?text=Healthcare',
    duration: '8개월',
    teamSize: 12,
    technologies: ['vue', 'spring', 'mysql', 'azure'],
    features: [
      '환자 예약 관리 시스템',
      '전자 의료 기록(EMR)',
      '원격 진료 플랫폼',
      'HIPAA 준수 보안'
    ],
    results: {
      efficiency: '업무 효율성 40% 향상',
      patientSatisfaction: '환자 만족도 92%',
      dataProcessing: '처리 속도 3배 향상'
    }
  },
  {
    id: 3,
    title: 'Food Delivery App',
    client: '푸드테크 스타트업 C',
    category: 'mobile',
    description: '실시간 배달 추적, AI 기반 맛집 추천 기능을 갖춘 푸드 딜리버리 앱',
    thumbnail: 'https://via.placeholder.com/600x400/F59E0B/ffffff?text=Food+Delivery',
    duration: '4개월',
    teamSize: 6,
    technologies: ['reactnative', 'nodejs', 'mongodb', 'aws'],
    features: [
      '실시간 배달 추적',
      'AI 맛집 추천',
      '간편 결제 시스템',
      '리뷰 및 평점 시스템'
    ],
    results: {
      downloads: '출시 3개월 10만 다운로드',
      retention: '월간 재사용률 65%',
      rating: '앱스토어 평점 4.8'
    }
  },
  {
    id: 4,
    title: 'Financial Dashboard',
    client: '핀테크 기업 D',
    category: 'web',
    description: '실시간 금융 데이터 시각화 대시보드. 포트폴리오 관리 및 투자 분석 도구',
    thumbnail: 'https://via.placeholder.com/600x400/8B5CF6/ffffff?text=Financial',
    duration: '5개월',
    teamSize: 7,
    technologies: ['react', 'typescript', 'django', 'postgresql', 'gcp'],
    features: [
      '실시간 데이터 시각화',
      '포트폴리오 분석 도구',
      '리스크 관리 시스템',
      '자동화된 리포트 생성'
    ],
    results: {
      accuracy: '데이터 정확도 99.9%',
      performance: '실시간 처리 지연 0.1초',
      userBase: '기업 고객 50개사 확보'
    }
  },
  {
    id: 5,
    title: 'Education Platform',
    client: '교육 기업 E',
    category: 'fullstack',
    description: '온라인 교육 플랫폼. 라이브 스트리밍, 과제 관리, 학습 분석 기능 포함',
    thumbnail: 'https://via.placeholder.com/600x400/EC4899/ffffff?text=Education',
    duration: '7개월',
    teamSize: 10,
    technologies: ['nextjs', 'nodejs', 'mongodb', 'aws'],
    features: [
      '라이브 스트리밍 수업',
      '과제 제출 및 평가',
      '학습 진도 분석',
      '소셜 학습 기능'
    ],
    results: {
      students: '누적 학생 수 10만명',
      completion: '과정 완료율 78%',
      satisfaction: '강사 만족도 95%'
    }
  },
  {
    id: 6,
    title: 'IoT Smart Home App',
    client: '스마트홈 기업 F',
    category: 'mobile',
    description: 'IoT 기기 통합 제어 앱. 음성 인식, 자동화 시나리오, 에너지 모니터링',
    thumbnail: 'https://via.placeholder.com/600x400/06B6D4/ffffff?text=Smart+Home',
    duration: '6개월',
    teamSize: 9,
    technologies: ['flutter', 'nodejs', 'mongodb', 'aws'],
    features: [
      'IoT 기기 통합 제어',
      '음성 인식 제어',
      '자동화 시나리오',
      '에너지 사용량 분석'
    ],
    results: {
      devices: '연동 기기 50종 이상',
      automation: '자동화 실행률 95%',
      energySaving: '평균 전력 절감 30%'
    }
  }
];